<template>
  <div>
    <validation-observer v-slot="{ invalid }" ref="single_stand">
      <b-row>
        <b-col md="7" lg="8" xl="8">
          <b-row>
            <b-col md="12" lg="12">
              <b-card-code :title="$t('info')">
                <b-row>
                  <b-col class="col-8">
                    <b-form-group
                      :label="$t('stand_name')"
                      label-for="stand_name"
                    >
                      <b-form-input
                        id="stand_name"
                        :placeholder="$t('insert_name')"
                        v-model="stand_name"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col class="col-4">
                    <b-form-group
                      :label="$t('Position') + ' *'"
                      label-for="stand_number"
                    >
                      <validation-provider
                        #default="{ errors }"
                        rules="integer|required"
                        name="Number"
                      >
                        <b-form-input
                          id="stand_number"
                          disabled
                          v-model="external_ref"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="$t('insert_number')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col class="col-12">
                    <b-form-group
                      :label="$t('referent_email')"
                      label-for="referent_email"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Email"
                        rules="email"
                      >
                        <b-form-input
                          id="referent_email"
                          v-model="manager_email"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="$t('add_email')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col class="col-12">
                    <b-form-group
                      :label="$t('short_description')"
                      label-for="stand_description"
                    >
                      <b-form-textarea
                        id="stand_description"
                        v-model="description"
                        :placeholder="$t('add_short_description')"
                        rows="4"
                        :state="statusColor"
                        class="char-textarea"
                        maxlength="350"
                        :class="
                          description.length >= maxChar ? 'text-danger' : ''
                        "
                      />
                      <small
                        class="textarea-counter-value float-right"
                        :class="
                          description.length >= maxChar ? 'bg-danger' : ''
                        "
                      >
                        <span class="char-count">{{ description.length }}</span>
                        /
                        {{ maxChar }}
                      </small>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-code>
            </b-col>
          </b-row>
          <!-- Loghi Upload -->
          <b-row class="logo-stand" hidden>
            <b-col md="6" lg="6">
              <b-card :title="$t('logo_stand')">
                <b-card-text>
                  {{ $t("main_logo_stand") }}
                </b-card-text>
                <b-form-file
                  accept=".jpg, .png"
                  ref="file-input"
                  :placeholder="$t('any_file_select')"
                  v-model="logo_stand"
                  @input="openEditor(logo_stand, 'logo_stand')"
                />
                <b-img
                  :src="preview_logo_stand"
                  id="preview-logo-stand"
                  class="image-preview"
                />
                <b-button id="open-editor" v-b-modal="'modal-editor'" hidden />
              </b-card>
            </b-col>
            <b-col md="6" lg="6" hidden>
              <b-card :title="$t('logo_floor')">
                <b-card-text>
                  {{ $t("negative_logo") }}
                </b-card-text>
                <b-form-file
                  accept=".jpg, .png"
                  ref="file-input"
                  :placeholder="$t('any_file_select')"
                  v-model="logo_floor"
                  @input="openEditor(logo_floor, 'logo_floor')"
                />
                <b-img
                  :src="preview_logo_floor"
                  id="preview-logo-floor"
                  class="image-preview"
                />
              </b-card>
            </b-col>
          </b-row>
          <!-- Gestione Pin Point -->
          <b-row>
            <b-col md="12" lg="12">
              <b-card-code :title="$t('pin_point_management')">
                <b-table
                  hover
                  small
                  :fields="fields"
                  :items="pinpoints"
                  responsive="sm"
                  class="table_stand"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(name)="data">
                    {{ data.item.label }}
                  </template>
                  <template #cell(status)="data">
                    <b-badge v-if="data.item.active" pill variant="success">
                      {{ $t("status_active") }}
                    </b-badge>
                    <b-badge v-else pill variant="danger">
                      {{ $t("status_inactive") }}
                    </b-badge>
                  </template>
                  <template #cell(action)="data">
                    <b-button
                      class="btn-icon rounded-circle"
                      variant="flat-primary"
                      @click="
                        $bvModal.show(
                          'modal-' + data.item.type.slug,
                          data.item.fields
                        )
                      "
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                  </template>
                </b-table>
              </b-card-code>
            </b-col>
          </b-row>

          <!-- Personalizzazioni -->
          <b-row>
            <b-col md="12" lg="12" class="table_stand">
              <b-card-code :title="$t('media')">
                <b-table
                  hover
                  small
                  :fields="fields_customizations"
                  :items="media"
                  responsive="sm"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(name)="data">
                    {{ $t(`media_label.${data.item.type.slug}`) }}
                  </template>
                  <template #cell(status)="data">
                    <b-badge v-if="data.item.active" pill variant="success">
                      {{ $t("status_active") }}
                    </b-badge>
                    <b-badge v-else pill variant="danger">
                      {{ $t("status_inactive") }}
                    </b-badge>
                  </template>
                  <template #cell(action)="data">
                    <b-button
                      @click="open_media_modal(data.item.type.slug)"
                      class="btn-icon rounded-circle"
                      variant="flat-primary"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                  </template>
                </b-table>
              </b-card-code>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" lg="12">
              <b-card :title="$t('stand_img')">
                <b-img
                  :src="stand_image"
                  id="stand-imgase"
                  class="image-preview"
                  style="max-width: 100%;"
                />
              </b-card>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="5" lg="4" xl="4">
          <b-card class="stand-dx">
            <b-button id="open-editor" v-b-modal="'modal-editor'" hidden />
            <h3>{{ stand_name }}</h3>
            <h6 class="text-muted">
              {{ $t("pavilion_ref") }}: {{ pavilion_ref }}
              <span class="stand_type">{{ stand_type }}</span>
            </h6>
            <hr class="mb-2" />
            <b-card-text>
              {{ $t("main_logo_stand") }}
            </b-card-text>
            <b-form-file
              accept=".jpg, .png"
              ref="file-input"
              :placeholder="$t('any_file_select')"
              v-model="logo_stand"
              @input="openEditor(logo_stand, 'logo_stand')"
            />
            <b-img
              :src="preview_logo_stand"
              id="preview-logo-stand"
              class="image-preview"
            />
            <hr class="mb-2" />

            <!-- follower projects rank -->
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="text-muted font-weight-bolder">
                  Pin
                </h6>
                <vue-apex-charts
                  type="radialBar"
                  height="100"
                  width="60"
                  :options="gaugeOverviewRadialBar.chartOptions"
                  :series="gauge_pin"
                />
                <span class="font-weight-bold text-body-heading mr-1">
                  {{ customization_data[0].pin_usage }} /
                  {{ customization_data[0].pin_total }}
                </span>
              </div>
              <div>
                <h6 class="text-muted font-weight-bolder">
                  Media
                </h6>
                <vue-apex-charts
                  type="radialBar"
                  height="100"
                  width="60"
                  :options="gaugeOverviewRadialBar.chartOptions"
                  :series="gauge_media"
                />
                <span class="font-weight-bold text-body-heading mr-1">
                  {{ customization_data[1].media_usage }} /
                  {{ customization_data[1].media_total }}
                </span>
              </div>
              <div>
                <h6 class="text-muted font-weight-bolder">
                  Logo
                </h6>
                <vue-apex-charts
                  type="radialBar"
                  height="100"
                  width="60"
                  :options="gaugeOverviewRadialBar.chartOptions"
                  :series="gauge_logo"
                />
                <span class="font-weight-bold text-body-heading mr-1">
                  {{ customization_data[2].logo_usage }} /
                  {{ customization_data[2].logo_total }}
                </span>
              </div>
            </div>
            <hr class="mb-2" />

            <b-card-text class="col-form-label">
              {{ $t("stand_link") }}
            </b-card-text>
            <div class="d-flex stand-link">
              <!-- form input -->
              <b-form-group class="mb-0 mr-1">
                <b-form-input
                  v-model="stand_url"
                  disabled
                  :placeholder="$t('placeholder_link_stand')"
                />
              </b-form-group>
              <b-button
                v-clipboard:copy="stand_url"
                v-clipboard:success="onCopyClip"
                v-clipboard:error="onErrorClip"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="primary"
              >
                {{ $t("copy") }}
              </b-button>
            </div>

            <b-card-text class="col-form-label mt-2" v-if="chat_url">
              {{ $t("chat_link") }}
            </b-card-text>
            <div class="d-flex stand-link" v-if="chat_url">
              <!-- form input -->
              <b-form-group class="mb-0 mr-1">
                <b-form-input
                  v-model="chat_url"
                  disabled
                  :placeholder="$t('placeholder_link_stand')"
                />
              </b-form-group>
              <b-button variant="secondary" @click="openChat" class="mr-1">
                <feather-icon size="16" icon="MessageSquareIcon" />
              </b-button>
              <b-button
                v-clipboard:copy="chat_url"
                v-clipboard:success="onCopyClip"
                v-clipboard:error="onErrorClip"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="primary"
              >
                <feather-icon size="16" icon="CopyIcon" />
              </b-button>
            </div>

            <!-- <b-form-group :label="$t('State')" class="mt-2">
              <b-form-select v-model="active" :options="state_options" />
            </b-form-group> -->
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              block
              variant="primary"
              class="mt-2"
              @click.prevent="saveData"
              :disabled="invalid"
            >
              {{ $t("save_edit") }}
            </b-button>
            <!--/ follower projects rank -->
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>

    <!-- pinpoints -->
    <component
      v-for="pinpoint in pinpoints"
      :ref="pinpoint.type.slug"
      :key="'pinpoint_' + pinpoint.id"
      :is="'pin-point-' + pinpoint.type.slug"
      :pinpoint="pinpoint"
      @open_editor="openEditor"
      @onSave="refreshPinpoint"
    ></component>

    <!-- media -->
    <media-image
      :ref="'media_simple_image'"
      :slug="current_slug"
      :media="current_media"
      @open_editor="openEditor"
      @onSave="refreshMedia"
    ></media-image>

    <media-full
      :ref="'media_full_data'"
      :slug="current_slug"
      :media="current_media"
      @open_editor="openEditor"
      @onSave="refreshMedia"
    ></media-full>

    <modal-editor
      :image="image"
      :type="type"
      :width="width"
      :height="height"
      @onSave="showPreview"
      @close="abortImageEdit"
    ></modal-editor>
  </div>
</template>

<script>
import BCardCode from "@core/components/b-card-code";
import {
  BBadge,
  BTable,
  BFormFile,
  BFormTextarea,
  BButton,
  BCard,
  BCardText,
  BLink,
  BFormInput,
  BRow,
  BCol,
  BFormGroup,
  BModal,
  VBModal,
  BFormSelect,
  BAvatar,
  BImg,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { required, email, integer } from "@validations";
import Ripple from "vue-ripple-directive";
import VueApexCharts from "vue-apexcharts";
import { $themeColors } from "@themeConfig";

//import pinpoint
import PinPointSite_link from "./pin_point/logo";
import PinPointContacts from "./pin_point/contacts";
import PinPointSocial from "./pin_point/social";
import PinPointCompany from "./pin_point/company";
import PinPointIndustry from "./pin_point/industry";
import PinPointProgram from "./pin_point/program";
import PinPointWorkshop from "./pin_point/workshop-live";
import PinPointOn_demand_webinar from "./pin_point/webinar-on-demand";
import PinPointCompany_webinar from "./pin_point/webinar-company";
import PinPointCustom_1 from "./pin_point/free-content-1";
import PinPointCustom_2 from "./pin_point/free-content-2";
import PinPointPromo from "./pin_point/promo";
import PinPointDocuments from "./pin_point/documents";
import PinPointGallery from "./pin_point/gallery";

//import personalization
import mediaImage from "./personalization/media_image";
import mediaFull from "./personalization/media_full";

//import photo editor
import ModalEditor from "../editor.vue";

import { getStand, updateStand } from "@api/stands";
import { getMediaByStand } from "@api/media";
import { getPinpointsByStand } from "@api/pinpoint";

import { FAIRERS_URL } from "@variables";

export default {
  components: {
    BCardCode,
    BModal,
    BBadge,
    BTable,
    BFormFile,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    BButton,
    BCard,
    BCardText,
    BLink,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BFormSelect,
    BImg,
    ToastificationContent,
    PinPointSite_link,
    PinPointContacts,
    PinPointSocial,
    PinPointCompany,
    PinPointIndustry,
    PinPointProgram,
    PinPointWorkshop,
    PinPointOn_demand_webinar,
    PinPointCompany_webinar,
    PinPointCustom_1,
    PinPointCustom_2,
    PinPointPromo,
    PinPointDocuments,
    PinPointGallery,
    ModalEditor,
    BAvatar,
    VueApexCharts,
    mediaImage,
    mediaFull,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      stand: null,
      preview_logo_stand: null,
      preview_logo_floor: null,
      stand_image: "",
      gaugeOverviewRadialBar: {
        chartOptions: {
          colors: ["#51e5a8"],
          plotOptions: {
            radialBar: {
              offsetY: -10,
              startAngle: -150,
              endAngle: 150,
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  show: false,
                },
              },
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 0.5,
              gradientToColors: [$themeColors.success],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            lineCap: "round",
          },
        },
      },
      gauge_pin: [],
      gauge_media: [],
      gauge_logo: [],
      customization_data: [
        {
          name: "Pin",
          pin_usage: null,
          pin_total: null,
        },
        {
          name: "Media",
          media_usage: null,
          media_total: null,
        },
        {
          name: "Logo",
          logo_usage: null,
          logo_total: 1,
        },
      ],
      logo_preview: null,
      image: null,
      type: null,
      width: 0,
      height: 0,
      stand_name: "",
      original: {
        stand_name: "",
        external_ref: "",
        manager_email: "",
        description: "",
        active: "",
      },
      external_ref: "",
      manager_email: "",
      description: "",
      logo_stand: null,
      logo_floor: null,
      pavilion_ref: "",
      maxChar: 350,
      stand_type: "Big",
      stand_url: "www.google.it",
      chat_url: "",
      fields: [
        { key: "index", label: "#" },
        { key: "name", label: this.$t("field_label_name") },
        { key: "status", label: this.$t("field_label_status") },
        { key: "action", label: this.$t("field_label_actions") },
      ],
      fields_customizations: [
        { key: "index", label: "#" },
        { key: "name", label: this.$t("field_label_name") },
        { key: "status", label: this.$t("field_label_status") },
        { key: "action", label: this.$t("field_label_actions") },
      ],
      pinpoints: [],
      media: [],
      active: false,
      state_options: [
        { value: true, text: this.$t("status_published") },
        { value: false, text: this.$t("status_inactive") },
      ],
      aspect_ratio: 1,
      crop_limit: {
        logo_stand: {
          width: 840,
          height: 300,
        },
        logo_floor: {
          width: 840,
          height: 300,
        },
        contacts: {
          width: 160,
          height: 160,
        },
        poster_1: {
          width: 300,
          height: 450,
        },
        poster_large: {
          width: 1280,
          height: 720,
        },
        screen: {
          width: 1280,
          height: 720,
        },
        gallery: {
          width: -1,
          height: -1,
        },
      },
      current_media: "",
      current_slug: "",
      //media type e ratio
      media_info: {
        tv_e: {
          ratio: 0.56,
          width: 256,
          fields: "full",
        },
        logo_desk_e: {
          ratio: 1,
          width: 256,
          fields: "image",
        },
        logo_wall_e: {
          ratio: 1,
          width: 256,
          fields: "image",
        },
        videowall_e: {
          ratio: 0.56,
          width: 256,
          fields: "full",
        },
        media_1_e: {
          ratio: 1,
          width: 256,
          fields: "full",
        },
        media_2_e: {
          ratio: 1,
          width: 256,
          fields: "full",
        },
        rollup_e: {
          ratio: 1.33,
          width: 256,
          fields: "image",
        },
        media_3_e: {
          ratio: 1.37,
          fields: "image",
        },
        tv_m: {
          ratio: 0.56,
          width: 256,
          fields: "full",
        },
        logo_wall_m: {
          ratio: 0.5608,
          width: 256,
          fields: "image",
        },
        logo_desk_m: {
          ratio: 0.5608,
          fields: "image",
        },
        media_1_m: {
          ratio: 0.87,
          width: 640,
          fields: "full",
        },
        media_2_l: {
          ratio: 1.41,
          width: 256,
          fields: "full",
        },
        logo_wall_l: {
          ratio: 0.5,
          width: 256,
          fields: "image",
        },
        logo_desk_l: {
          ratio: 0.5,
          width: 256,
          fields: "image",
        },
        media_1_l: {
          ratio: 0.56,
          width: 256,
          fields: "image",
        },
        tv_l: {
          ratio: 0.56,
          width: 256,
          fields: "full",
        },
        media_3_xl: {
          ratio: 1.233,
          width: 256,
          fields: "image",
        },
        media_1_xl: {
          ratio: 0.56,
          width: 256,
          fields: "full",
        },
        media_2_xl: {
          ratio: 0.56,
          width: 256,
          fields: "full",
        },
        logo_wall_xl: {
          ratio: 0.516,
          width: 256,
          fields: "image",
        },
        logo_desk_xl: {
          ratio: 0.516,
          width: 256,
          fields: "image",
        },
        videowall_xl: {
          ratio: 0.75,
          width: 256,
          fields: "full",
        },
        tv_xl: {
          ratio: 0.56,
          width: 256,
          fields: "full",
        },
        rollup_xl: {
          ratio: 1.33,
          width: 256,
          fields: "image",
        },
      },
    };
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  created() {
    this.getData();
  },
  beforeRouteLeave(to, from, next) {
    if (this.checkIfDataAreChanged()) {
      next(false);
      this.$swal({
        title:
          '<span class="font-weight-bolder">' +
          this.$t("alert_title_warning") +
          "</span>",
        icon: "warning",
        text: this.$t("alert_save_changes"),
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: this.$t("alert_go_next_page"),
        cancelButtonText: this.$t("alert_stay_on_page"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      })
        .then((result) => {
          if (result.value) {
            next();
          } else {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      next();
    }
  },
  methods: {
    getData() {
      const $this = this;
      getStand(this.$route.params.id)
        .then((data) => {
          $this.initializeStandData(data);
        })
        .catch(() => {
          this.$router.push({ path: `/error-404/` });
        });
    },
    initializeStandData(data) {
      //TODO: refactory usare this.stand per i dati dello stand
      this.stand = data;
      this.stand_name = data.name;
      this.original.stand_name = data.name;
      //HACK: per modificarlo in modo semplice
      document.getElementById("breadcrumbsPageTitleCustom").innerHTML =
        data.name;
      this.external_ref = data.external_ref;
      this.original.external_ref = data.external_ref;
      this.manager_email = data.manager_email;
      this.original.manager_email = data.manager_email;
      this.description = data.description;
      this.original.description = data.description;
      this.active = data.active;
      this.original.active = data.active;
      if (data.logo != "") {
        this.showPreview("logo_stand", data.logo_url);
      }
      if (data.floor_logo != "") {
        this.showPreview("logo_floor", data.floor_logo_url);
      }
      this.pavilion_ref = data.pavilion_ref;
      this.stand_type = data.type.label;
      this.stand_url = this.createStandUrl(data.pavilion_ref);
      this.chat_url = this.createChatUrl(data.manager_email);
      this.pinpoints = data.pinpoints;
      this.media = data.media;
      this.setPinGauge();
      this.setMediaGauge();
      this.setLogoGauge();
      this.setStandImage(data.type.id);
    },
    setStandImage(id) {
      //Selezione l'immagine dello stand corretta
      switch (id) {
        case 1:
          //enterprise
          this.stand_image = require("@/assets/images/pages/media-stand/Enterprise.jpg");
          break;
        case 2:
          //medium
          this.stand_image = require("@/assets/images/pages/media-stand/M.jpg");
          break;
        case 3:
          //large
          this.stand_image = require("@/assets/images/pages/media-stand/L.jpg");
          break;
        case 4:
          //extralarge
          this.stand_image = require("@/assets/images/pages/media-stand/XL.jpg");
          break;
      }
    },
    createStandUrl(stand_panorama) {
      return `${FAIRERS_URL}/space?stand=${stand_panorama}`;
    },
    createChatUrl(manager_email) {
      if (manager_email) {
        return `${FAIRERS_URL}/rep-chat?email=${manager_email}`;
      } else {
        return `${FAIRERS_URL}/rep-chat`;
      }
    },
    openChat() {
      window.open(this.chat_url);
    },
    setPinGauge() {
      this.gauge_pin = [];
      this.customization_data[0].pin_usage = this.countActiveCustomizations(
        this.pinpoints
      );
      this.customization_data[0].pin_total = this.pinpoints.length;
      this.setPercentageGauge(this.customization_data[0]);
    },
    setMediaGauge() {
      this.gauge_media = [];
      this.customization_data[1].media_usage = this.countActiveCustomizations(
        this.media
      );
      this.customization_data[1].media_total = this.media.length;
      this.setPercentageGauge(this.customization_data[1]);
    },
    setLogoGauge() {
      this.gauge_logo = [];
      let logo_count = 0;
      if (this.logo_preview != null) {
        logo_count++;
      }
      if (this.preview_logo_floor != null) {
        logo_count++;
      }
      this.customization_data[2].logo_usage = logo_count;
      this.setPercentageGauge(this.customization_data[2]);
    },
    countActiveCustomizations(data) {
      let count = 0;
      for (let i = 0; i < data.length; ++i) {
        if (data[i].edited) {
          count++;
        }
      }
      return count;
    },
    setPercentageGauge(data) {
      if (data.name == "Pin") {
        this.gauge_pin.push(
          Math.round((data.pin_usage / data.pin_total) * 100)
        );
      } else if (data.name == "Media") {
        this.gauge_media.push(
          Math.round((data.media_usage / data.media_total) * 100)
        );
      } else if (data.name == "Logo") {
        this.gauge_logo.push(
          Math.round((data.logo_usage / data.logo_total) * 100)
        );
      }
    },
    checkIfDataAreChanged() {
      if (
        this.stand_name == this.original.stand_name &&
        this.external_ref == this.original.external_ref &&
        this.manager_email == this.original.manager_email &&
        this.description == this.original.description &&
        this.active == this.original.active &&
        !this.logo_stand &&
        !this.logo_floor
      ) {
        return false;
      } else {
        return true;
      }
    },
    openEditor(file, type) {
      if (file != null) {
        this.image = file;
        this.type = type;
        if (typeof this.crop_limit[type] === "undefined") {
          this.aspect_ratio = this.media_info[type].ratio;
          this.height = this.aspect_ratio * this.media_info[type].width;
          this.width = this.media_info[type].width;
        } else {
          this.width = this.crop_limit[type].width;
          this.height = this.crop_limit[type].height;
        }
        this.$bvModal.show("modal-editor");
      }
    },
    showPreview(type, imageUrl, image = null) {
      if (type == "logo_stand") {
        this.logo_stand = image;
        this.preview_logo_stand = imageUrl;
        this.logo_preview = imageUrl;
      } else if (type == "logo_floor") {
        this.logo_floor = image;
        this.preview_logo_floor = imageUrl;
      } else if (type == "contacts") {
        this.$refs.contacts[0].file = image;
        this.$refs.contacts[0].preview_contacts = imageUrl;
      } else if (type == "gallery") {
        this.$refs.gallery[0].showImg(image, imageUrl);
      } else {
        if (this.media_info[type].fields === "image") {
          this.$refs.media_simple_image.media_file = image;
          this.$refs.media_simple_image.preview_media = imageUrl;
        } else {
          this.$refs.media_full_data.image_file = image;
          this.$refs.media_full_data.preview_image = imageUrl;
        }
      }
    },
    abortImageEdit(type) {
      if (type == "logo_stand") {
        this.logo_stand = null;
      } else if (type == "logo_floor") {
        this.logo_floor = null;
      } else if (type == "contacts") {
        this.$refs.contacts[0].emptyField();
      } else if (type == "gallery") {
        this.$refs.gallery[0].emptyField();
      } else {
        if (this.media_info[type].fields === "image") {
          this.$refs.media_simple_image.emptyField();
        } else {
          this.$refs.media_full_data.emptyField();
        }
      }
    },
    open_media_modal(slug) {
      this.current_slug = slug;
      var index = this.stand.type.media.findIndex((x) => x == slug);
      if (index < 0) {
        return;
      }
      this.current_media = this.media[index];
      this.delay(500).then(() => {
        if (this.media_info[slug].fields === "image") {
          this.$bvModal.show("modal-image");
        } else {
          this.$bvModal.show("modal-full");
        }
      });
    },
    delay(time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    onCopyClip() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: this.$t("text_copied"),
          icon: "BellIcon",
        },
      });
    },
    onErrorClip() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: this.$t("failed_text_copied"),
          icon: "BellIcon",
        },
      });
    },
    refreshPinpoint() {
      getPinpointsByStand(this.$route.params.id)
        .then((data) => {
          this.pinpoints = data;
          this.setPinGauge();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    refreshMedia() {
      getMediaByStand(this.$route.params.id)
        .then((data) => {
          this.media = data;
          this.setMediaGauge();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveData() {
      const $this = this;
      this.$refs.single_stand.validate().then((success) => {
        if (success) {
          $this.save();
        }
      });
      return false;
    },
    save() {
      const $this = this;
      let formData = new FormData();
      formData.append("name", $this.stand_name);
      formData.append("manager_email", $this.manager_email);
      formData.append("external_ref", $this.external_ref);
      formData.append("description", $this.description);
      if ($this.logo_stand) {
        formData.append("logo", $this.logo_stand);
      }
      if ($this.logo_floor) {
        formData.append("floor_logo", $this.logo_floor);
      }
      formData.append("active", $this.active ? 1 : 0);
      updateStand(this.$route.params.id, formData)
        .then((data) => {
          $this.$toast({
            component: ToastificationContent,
            props: {
              title: $this.$t("save_complete"),
              icon: "EditIcon",
              variant: "success",
            },
          });
          $this.initializeStandData(data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    statusColor() {
      if (this.description.length > this.maxChar) {
        return false;
      } else if (this.description.length > 0) {
        return true;
      } else {
        return null;
      }
    },
  },
};
</script>

<style>
.preview-img img {
  width: 200px;
  position: relative;
  left: 50%;
  top: 50%;
  padding-top: 10px;
  transform: translate(-50%, 0%);
}
</style>
